const noop = () => {};

const METHODS: Array<keyof Console> = ['log', 'info', 'debug', 'trace'];

export const disableConsoleInProduction = () => {
  if (import.meta.env.DEV) {
    return;
  }

  METHODS.forEach((method) => {
    if (typeof console[method] === 'function') {
      console[method] = noop as any;
    }
  });
};

